module.exports = __webpack_public_path__ + "img/imba_hurricane_pike.742afe3f.png";